import{defineMessages}from'react-intl';

export default defineMessages({

showMore:{
id:'i18n.EventDetailsTab.showMore',
defaultMessage:'Show More'},

showLess:{
id:'i18n.EventDetailsTab.showLess',
defaultMessage:'Show Less'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1Nob3dNb3JlL1Nob3dNb3JlLm1lc3NhZ2VzLmpzIl0sIm5hbWVzIjpbImRlZmluZU1lc3NhZ2VzIiwic2hvd01vcmUiLCJpZCIsImRlZmF1bHRNZXNzYWdlIiwic2hvd0xlc3MiXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7O0FBRTVCQyxTQUFVO0FBQ1JDLEdBQUksK0JBREk7QUFFUkMsZUFBZ0IsV0FGUixDQUZrQjs7QUFNNUJDLFNBQVU7QUFDUkYsR0FBSSwrQkFESTtBQUVSQyxlQUFnQixXQUZSLENBTmtCLENBQWYsQ0FBZiIsImZpbGUiOiJTaG93TW9yZS5tZXNzYWdlcy5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuXG4gIHNob3dNb3JlOiB7XG4gICAgaWQ6ICdpMThuLkV2ZW50RGV0YWlsc1RhYi5zaG93TW9yZScsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdTaG93IE1vcmUnLFxuICB9LFxuICBzaG93TGVzczoge1xuICAgIGlkOiAnaTE4bi5FdmVudERldGFpbHNUYWIuc2hvd0xlc3MnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnU2hvdyBMZXNzJyxcbiAgfSxcbn0pO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/components/ShowMore/ShowMore.messages.js
// module id = 2168
// module chunks = 0